import t from 'tcomb';
import jsdk from '../../jsdk';
import UUID from '../../web/domain/UUID';
import Arr_Schema from '../../web/domain/Arr_Schema';
import Validation from '../../web/domain/Validation';
import Matrix_Style from '../../web/domain/style/Matrix_Style';


const Matrix_Input = t.struct({
  id: UUID,
  style: Matrix_Style,
  questions: t.list(t.tuple([t.Str, t.Str])),
  options: t.list(t.tuple([t.Str, t.Str])),
  schema: Arr_Schema
}, 'Matrix_Input');

Matrix_Input.prototype.set_error = function(message) {
  $("#" + this.id + "_error").html(message);
};

Matrix_Input.prototype.focus = function() {
  $('#' + this.id + ' [name=' + this.questions[0][0] + ']:nth(0)').focus();
};
Matrix_Input.prototype.to_html = function() {
  var self = this;
  var columns = this.options.map(function(option) {
    return option[1];
  });
  columns.unshift('&nbsp;');
  var rows = this.questions.map(function(question) {
    var row = self.options.map(function(option) {
      return jsdk.dom.radio({
        name: question[0],
        value: option[0]
      });
    });
    row.unshift(String(question[1]));
    return row;
  });
  // i margini vanno sul contenitore
  var styles = jsdk.split_margins(this.style);
  var html = '<div id="' + this.id + '" style="overflow: auto;">' + jsdk.table(columns, rows, {
    'class': ['table'],
    style: styles.other
  }) + '</div>';
  return jsdk.Form.wrap_input(this.id, html, styles.margins);
};

Matrix_Input.prototype.value = function(locale) {
  //jsdk.assert(Locale.is(locale));
  var self = this;
  var values = [];
  this.questions.forEach(function(question) {
    values.push([
      question[0], ($('#' + self.id + ' input[name=' + question[0] + ']:checked').val() || null)
    ]);
  });

  //calcolo quanti sono non nulli per la validazione
  var not_nulls = values.filter(function(pair) {
    return pair[1] !== null;
  });
  var validation = this.schema.validate(not_nulls);
  this.set_error(validation.rule ? validation.rule.localize(locale) : '');
  return validation.rule ? validation : new Validation({x: values, rule: null});
};

jsdk.Form.add_input('reducer/matrix', Matrix_Input);

export default Matrix_Input;


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/form/reducer/Matrix_Input.js
 **/